<ng-container *ngFor="let edd of eventDetailDialogs; let idx = index;">
  <ng-container *ngIf="!edd.minimized">
    <app-modal *ngIf="!edd.content.isAlarm && !edd.content.isFlowInspect && !edd.content.isFlowTest"
      [modalTitle]="edd.content ? edd.content.type+' - '+ (edd.content.key) : ''" [width]="700" [height]="400"
      [minimizable]="true" [zIndex]="1100" [multipleDialogOffset]="idx" [scrollTop]="true"
      (closeModal)="closeEventDetailsModal(edd)" (minimizeModal)="minimizeEventDetailsModal(edd)" [backdrop]="false"
      [maximizable]="true">
      <div class="app-modal-body" id="eventDetails-{{edd.id}}">

        <context-menu #eventDetailsContextMenu>
          <ng-template contextMenuItem (execute)="setQueryString($event)">
            <i class="mio vam mr-1">search</i>Search events with this value
          </ng-template>

          <ng-template contextMenuItem (execute)="showTokenization($event)">
            <i class="mio vam mr-1">account_tree</i>Show tokenization for this value
          </ng-template>

          <ng-template contextMenuItem (execute)="parseJson($event)">
            <i class="mio vam mr-1">code</i>Pretty print this value
          </ng-template>
        </context-menu>

        <div *ngIf="edd.tokenization != null" class="mb-2">
          <h4>Tokenization</h4>
          <div class="code-view" class="mb-3">
            <span *ngFor="let token of edd.tokenization" class="badge badge-secondary mr-2 mb-1 py-1 px-2"
              style="font-size: 13px;">{{token}}</span>
          </div>
        </div>
        <div class="mb-3" *ngIf="edd.parsedText != null">
          <h4>Pretty print</h4>
          <pre class="code-view" [innerHTML]="edd.parsedText | prettyjson:2"></pre>
        </div>
        <table class="table table-sm table-hover table-striped table-sm table-outline table-event-details">
          <tbody>
            <tr *ngFor="let singleResultProperty of edd.content.searchResultProperties">
              <td style="width: 30px;">
                <div ngbDropdown class="d-inline-block no-arrow small" [autoClose]="true">
                  <a ngbDropdownToggle><i class="mio vat pointer text-muted font-size-normal">more_vert</i></a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem
                      (click)="setQueryString(singleResultProperty.key+': &quot;'+singleResultProperty.value+'&quot;')"><i
                        class="mi vat mr-2">search</i>Search events with this field and
                      value</button>
                    <button ngbDropdownItem (click)="setQueryString(singleResultProperty.key+': *')"><i
                        class="mio vat mr-2">search</i>Search events with this field</button>
                    <button ngbDropdownItem (click)="setQueryString('&quot;'+singleResultProperty.value+'&quot;')"><i
                        class="mitt vat mr-2">search</i>Search events with this value</button>
                    <ng-container
                      *ngIf="fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'">

                      <div class="dropdown-divider"></div>
                      <button ngbDropdownItem (click)="showTokenization(singleResultProperty.value, edd)"><i
                          class="mio vat mr-2">account_tree</i>Show tokenization for this value</button>
                      <button ngbDropdownItem (click)="parseJson(singleResultProperty.value, edd)"><i
                          class="mitt vat mr-2">code</i>Pretty print value</button>
                    </ng-container>
                  </div>
                </div>
              </td>
              <td style="min-width: 140px; max-width: 200px; overflow-x: auto; word-break: break-all;"
                class="text-left">
                <strong>{{singleResultProperty.key}}</strong>
              </td>
              <td style="word-break: break-all;"
                (mousedown)="setSelectedText({key: singleResultProperty.key,value:singleResultProperty.value, edd: edd})"
                (mouseup)="setSelectedText({key: singleResultProperty.key,value:singleResultProperty.value, edd: edd})"
                [contextMenu]="eventDetailsContextMenu" [contextMenuSubject]="edd">
                <ng-container *ngIf="!fieldMappings[singleResultProperty.key]">
                  <code class="color-dark" [innerHtml]="singleResultProperty.value"></code>
                </ng-container>
                <ng-container
                  *ngIf="fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type == 'number'">
                  <code class="color-dark" [innerHtml]="singleResultProperty.value | number"></code>
                </ng-container>

                <ng-container
                  *ngIf="singleResultProperty.highlight != null && fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type != 'number'">
                  <code class=" color-dark text-highlight"
                    [ngClass]="{'modal-highlight': (singleResultProperty.highlight == null || singleResultProperty.highlight.length > 150)}"
                    [innerHtml]="singleResultProperty.highlight || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="(singleResultProperty.highlight == null || singleResultProperty.highlight.length > 150) && (fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type != 'number')">
                  <code class="color-dark" [innerHtml]="singleResultProperty.value || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type == 'date'">
                  <code
                    class="color-dark">{{singleResultProperty.value |  date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''}} - ({{singleResultProperty.value}})</code>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>




      </div>
    </app-modal>


    <app-modal *ngIf="edd.content.isAlarm"
      [modalTitle]="'['+getProperty('status', edd.content.searchResultProperties).value+'] '+getProperty('message', edd.content.searchResultProperties).value"
      [width]="800" [height]="600" [minimizable]="true" [zIndex]="1100" [multipleDialogOffset]="idx" [scrollTop]="true"
      (closeModal)="closeEventDetailsModal(edd)" (minimizeModal)="minimizeEventDetailsModal(edd)" [backdrop]="false"
      [maximizable]="true">
      <div class="app-modal-body" id="eventDetails-{{edd.id}}">

        <context-menu #eventDetailsContextMenu>
          <ng-template contextMenuItem (execute)="setQueryString($event)">
            <i class="mio vam mr-1">search</i>Search events with this value
          </ng-template>

          <ng-template contextMenuItem (execute)="showTokenization($event)">
            <i class="mio vam mr-1">account_tree</i>Show tokenization for this value
          </ng-template>

          <ng-template contextMenuItem (execute)="parseJson($event)">
            <i class="mio vam mr-1">code</i>Pretty print this value
          </ng-template>
        </context-menu>
        <h4>Alarm details</h4>
        <table class="table table-sm table-hover table-striped table-sm table-outline table-event-details">
          <tbody>
            <tr *ngFor="let singleResultProperty of edd.content.visibleFieldsMapping; let idx = index">
              <td style="width: 30px;">
                <div ngbDropdown class="d-inline-block no-arrow small" [autoClose]="true">
                  <a ngbDropdownToggle><i class="mio vat pointer text-muted font-size-normal">more_vert</i></a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem
                      (click)="setQueryString(getProperty(singleResultProperty, edd.content.searchResultProperties).key+': &quot;'+getProperty(singleResultProperty, edd.content.searchResultProperties).value+'&quot;')"><i
                        class="mi vat mr-2">search</i>Search events with this field and
                      value</button>
                    <button ngbDropdownItem
                      (click)="setQueryString(getProperty(singleResultProperty, edd.content.searchResultProperties).key+': *')"><i
                        class="mio vat mr-2">search</i>Search events with this field</button>
                    <button ngbDropdownItem
                      (click)="setQueryString('&quot;'+getProperty(singleResultProperty, edd.content.searchResultProperties).value+'&quot;')"><i
                        class="mitt vat mr-2">search</i>Search events with this value</button>
                    <ng-container
                      *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'">


                    </ng-container>
                  </div>
                </div>
              </td>
              <td style="min-width: 140px; max-width: 200px; overflow-x: auto; word-break: break-all;"
                class="text-left">
                <strong>{{edd.content.visibleFieldsLabel[singleResultProperty] ?
                  edd.content.visibleFieldsLabel[singleResultProperty] : singleResultProperty}}</strong>
              </td>
              <td style="word-break: break-all;" [contextMenu]="eventDetailsContextMenu" [contextMenuSubject]="edd">
                <ng-container
                  *ngIf="!fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key]">
                  <code class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value"></code>
                </ng-container>
                <ng-container
                  *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type == 'number'">
                  <code class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value | number"></code>
                </ng-container>

                <ng-container
                  *ngIf="getProperty(singleResultProperty, edd.content.searchResultProperties).highlight != null && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'number'">

                  <code class=" color-dark text-highlight"
                    [ngClass]="{'modal-highlight': (getProperty(singleResultProperty, edd.content.searchResultProperties).highlight == null || getProperty(singleResultProperty, edd.content.searchResultProperties).highlight.length > 150)}"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).highlight || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="(getProperty(singleResultProperty, edd.content.searchResultProperties).highlight == null || getProperty(singleResultProperty, edd.content.searchResultProperties).highlight.length > 150) && (fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'number')">
                  <ng-container
                    *ngIf="isMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)">
                    <code class="color-dark text-highlight markdownView">
														<markdown  [data]="parseMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)"></markdown>
														</code>
                  </ng-container>
                  <code *ngIf="!isMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)"
                    class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type == 'date'">
                  <code
                    class="color-dark">{{getProperty(singleResultProperty, edd.content.searchResultProperties).value |  date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''}} - ({{getProperty(singleResultProperty, edd.content.searchResultProperties).value}})</code>
                </ng-container>
              </td>
            </tr>


            <tr *ngFor="let singleResultProperty of edd.content.additionalFieldsMapping; let idx = index">
              <td style="width: 30px;">
                <div ngbDropdown class="d-inline-block no-arrow small" [autoClose]="true">
                  <a ngbDropdownToggle><i class="mio vat pointer text-muted font-size-normal">more_vert</i></a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem
                      (click)="setQueryString(getProperty(singleResultProperty, edd.content.searchResultProperties).key+': &quot;'+getProperty(singleResultProperty, edd.content.searchResultProperties).value+'&quot;')"><i
                        class="mi vat mr-2">search</i>Search events with this field and
                      value</button>
                    <button ngbDropdownItem
                      (click)="setQueryString(getProperty(singleResultProperty, edd.content.searchResultProperties).key+': *')"><i
                        class="mio vat mr-2">search</i>Search events with this field</button>
                    <button ngbDropdownItem
                      (click)="setQueryString('&quot;'+getProperty(singleResultProperty, edd.content.searchResultProperties).value+'&quot;')"><i
                        class="mitt vat mr-2">search</i>Search events with this value</button>
                    <ng-container
                      *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'">


                    </ng-container>
                  </div>
                </div>
              </td>
              <td style="min-width: 140px; max-width: 200px; overflow-x: auto; word-break: break-all;"
                class="text-left">
                <strong>{{edd.content.additionalFieldsLabel[idx]}}</strong>
              </td>
              <td style="word-break: break-all;" [contextMenu]="eventDetailsContextMenu" [contextMenuSubject]="edd">
                <ng-container
                  *ngIf="!fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key]">
                  <code class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value"></code>
                </ng-container>
                <ng-container
                  *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type == 'number'">
                  <code class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value | number"></code>
                </ng-container>

                <ng-container
                  *ngIf="getProperty(singleResultProperty, edd.content.searchResultProperties).highlight != null && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'number'">
                  <code class=" color-dark text-highlight"
                    [ngClass]="{'modal-highlight': (getProperty(singleResultProperty, edd.content.searchResultProperties).highlight == null || getProperty(singleResultProperty, edd.content.searchResultProperties).highlight.length > 150)}"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).highlight || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="(getProperty(singleResultProperty, edd.content.searchResultProperties).highlight == null || getProperty(singleResultProperty, edd.content.searchResultProperties).highlight.length > 150) && (fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'date'&& fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type != 'number')">

                  <code class="color-dark"
                    [innerHtml]="getProperty(singleResultProperty, edd.content.searchResultProperties).value || '-'"></code>
                </ng-container>

                <ng-container
                  *ngIf="fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key] && fieldMappings[getProperty(singleResultProperty, edd.content.searchResultProperties).key].type == 'date'">
                  <ng-container
                    *ngIf="isMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)">
                    <code class="color-dark text-highlight markdownView">
														<markdown  [data]="parseMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)"></markdown>
														</code>
                  </ng-container>
                  <code *ngIf="!isMarkdown(getProperty(singleResultProperty, edd.content.searchResultProperties).value)"
                    class="color-dark"></code>

                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-container *ngIf="edd.content.runActionRequestHistory && edd.content.runActionRequestHistory.length > 0">
          <h4>Alarm history</h4>
          <div class="row" *ngFor="let historyElement of edd.content.runActionRequestHistory; let idx = index">
            <div class="col-auto text-center flex-column d-none d-sm-flex">
              <div class="row h-50">
                <div class="col" [ngClass]="{'border-right':idx > 0}">&nbsp;</div>
                <div class="col">&nbsp;</div>
              </div>
              <h5 class="m-2">
                <span class="badge badge-pill border"
                  [ngClass]="{'bg-success' : historyElement.actionStatus == 'SUCCESS','bg-light' : historyElement.actionStatus == 'PENDING','bg-warning' : historyElement.actionStatus == 'ERROR'}">&nbsp;</span>
              </h5>
              <div class="row h-50">
                <div class="col" [ngClass]="{'border-right':idx < edd.content.runActionRequestHistory.length-1}">
                  &nbsp;</div>
                <div class="col">&nbsp;</div>
              </div>
            </div>
            <!-- timeline item 1 event content -->
            <div class="col mb-3">
              <div class="card bg-light">
                <div class="card-body ">
                  <div class="float-right text-muted text-right">
                    <p class="badge badge-pill py-1 px-2 m-0 mb-1" style="font-size:11px;"
                      [ngClass]="{'badge-success' : historyElement.actionStatus == 'SUCCESS','badge-light' : historyElement.actionStatus == 'PENDING','badge-warning' : historyElement.actionStatus == 'ERROR'}">
                      {{historyElement.actionStatus}} </p>
                    <p class="m-0">{{historyElement.actionMessage}}</p>
                  </div>
                  <h4 class="card-title mb-0">{{historyElement.actionLabel}}</h4>
                  <p class="m-0 mb-2"><span class="text-muted "> Managed by:</span> {{historyElement.managedBy}} -
                    <span class="text-muted "> Action time:</span>
                    {{historyElement.runActionTime | date:
                    user.options['dateFormat'] :
                    user.options['timeZone'] != 'Client default' ?
                    user.options['timeZone'] : ''}}
                  </p>
                  <ng-container *ngIf="historyElement.runActionFields">
                    <ul class="list-group mb-2">
                      <ng-container *ngFor="let runActionField of historyElement.runActionFields|keyvalue">
                        <li class="list-group-item d-flex justify-content-start align-items-center">
                          <span style="width: 120px;">{{runActionField.key}}</span>
                          <ng-container *ngIf="isMarkdown(runActionField.value)">
                            <span class="markdownView">
														<markdown  [data]="parseMarkdown(runActionField.value)"></markdown>
														</span>
                          </ng-container>
                          <span *ngIf="!isMarkdown(runActionField.value)" class="pl-3">{{runActionField.value}}</span>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>
                  <ul class="list-group mb-2">
                    <li class="list-group-item d-flex justify-content-start align-items-center">
                      <span style="width: 120px;">Notes</span>
                      <span class="pl-3">{{historyElement.notes || 'n.d.'}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-container>


      </div>
    </app-modal>

    <!-- FlowInspect -->
    <app-modal *ngIf="edd.content.isFlowInspect"
      [modalTitle]="getProperty('flowInstanceId', edd.content.searchResultProperties).value" [width]="950"
      [height]="650" [minimizable]="true" [zIndex]="1100" [multipleDialogOffset]="idx" [scrollTop]="true"
      (closeModal)="closeEventDetailsModal(edd)" (minimizeModal)="minimizeEventDetailsModal(edd)" [backdrop]="false"
      [maximizable]="true">
      <div class="app-modal-body" id="eventDetails-{{edd.id}}">
        <app-flow-inspect-table-event-details [content]="edd.content"></app-flow-inspect-table-event-details>
      </div>
    </app-modal>
    <!-- FlowInspect -->

    <!-- FlowTest -->
    <app-modal *ngIf="edd.content.isFlowTest" [modalTitle]="'Test flow type. Code: '+edd.content.key" [width]="1000"
      [height]="850" [minimizable]="true" [zIndex]="1100" [multipleDialogOffset]="idx" [scrollTop]="true"
      (closeModal)="closeEventDetailsModal(edd)" (minimizeModal)="minimizeEventDetailsModal(edd)" [backdrop]="false"
      [maximizable]="true">
      <div class="app-modal-body" id="eventDetails-{{edd.id}}">
        <app-flow-management-test [content]="edd.content"></app-flow-management-test>

      </div>
    </app-modal>
    <!-- FlowTest -->
  </ng-container>
</ng-container>

<div class="event-detail-dialogs-tray closed shadow" *ngIf="eventDetailDialogs">
  <div class="event-detail-tray-header" (click)="isEventDetailDialogsTrayOpen = !isEventDetailDialogsTrayOpen">
    <span class="badge badge-primary mr-2">{{eventDetailDialogs.length | json}}</span>
    <span *ngIf="eventDetailDialogs.length > 0">Saved events</span>
    <span *ngIf="eventDetailDialogs.length == 0">No saved events</span>
    <span class="float-right" *ngIf="isEventDetailDialogsTrayOpen">
      <i class="mio vam">keyboard_arrow_down</i>
    </span>
    <span class="float-right" *ngIf="!isEventDetailDialogsTrayOpen">
      <i class="mio vam">keyboard_arrow_up</i>
    </span>
  </div>
  <ng-container *ngIf="isEventDetailDialogsTrayOpen && eventDetailDialogs.length == 0">
    <div class="event-detail-dialogs-list">
      <p class="text-muted"> No saved events</p>
    </div>
  </ng-container>
  <ng-container *ngIf="isEventDetailDialogsTrayOpen && eventDetailDialogs.length > 0">
    <div class="event-detail-dialogs-list">
      <div *ngFor="let edd of eventDetailDialogs" class="row">
        <div class="col-lg-12 mb-1">
          <span class="float-left pointer p-1 mr-1" (click)="closeEventDetailsModal(edd)">
            <i class="mio vam">close</i>
          </span>
          <span *ngIf="edd.minimized" (click)="edd.minimized = false" class="float-left pointer event-details-element">
            <span *ngIf="!edd.content.isAlarm && !edd.content.isFlowInspect">{{edd.content.key | trim: 40}}</span>
            <span *ngIf="edd.content.isAlarm">{{'['+(getProperty('status', edd.content.searchResultProperties).value+']
              '+getProperty('message', edd.content.searchResultProperties).value) | trim: 40}}</span>
            <span
              *ngIf="edd.content.isFlowInspect">{{getProperty('flowInstanceId',edd.content.searchResultProperties).value}}</span>
            <br />
            <small class="text-muted"><strong>{{edd.content.type}}</strong> -
              {{edd.timestamp | date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ?
              user.options['timeZone'] : ''}}</small></span>
          <span *ngIf="!edd.minimized" (click)="edd.minimized = true" class="float-left pointer event-details-element">
            <span *ngIf="!edd.content.isAlarm && !edd.content.isFlowInspect">{{edd.content.key | trim: 40}}</span>
            <span *ngIf="edd.content.isAlarm">{{'['+(getProperty('status', edd.content.searchResultProperties).value+']
              '+getProperty('message', edd.content.searchResultProperties).value) | trim: 40}}</span>
            <span
              *ngIf="edd.content.isFlowInspect">{{getProperty('flowInstanceId',edd.content.searchResultProperties).value}}</span>

            <br />
            <small class="text-muted">
              <strong>{{edd.content.type}}</strong> -
              {{edd.timestamp| date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ?
              user.options['timeZone'] : ''}}</small></span>
          <span *ngIf="edd.minimized" class="float-right  pointer p-1" (click)="edd.minimized = false">
            <i class="mio vam">zoom_out_map</i>
          </span>
          <span *ngIf="!edd.minimized" class="float-right pointer p-1" (click)="edd.minimized = true">
            <i class="mio vam">minimize</i>
          </span>
        </div>
      </div>
    </div>
    <div class="event-detail-tray-footer bg-gray-100">
      <button (click)="saveEventDetails(eventDetailDialogs)" class="btn btn-sm btn-text float-right">Save
        event details</button>
    </div>
  </ng-container>
</div>